import { render, staticRenderFns } from "./JgsData.vue?vue&type=template&id=803aca52&"
import script from "./JgsData.vue?vue&type=script&lang=js&"
export * from "./JgsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports